import React from 'react';
import { Link } from 'react-router-dom';

function Team() {
  const teamMembers = [
    {
      name: 'Rajesh Kumar',
      role: 'CEO & Founder',
      image: 'https://images.unsplash.com/photo-1560250097-0b93528c311a?w=400&h=400&fit=crop&crop=face',
      bio: 'Visionary leader with 15+ years in tech industry',
      linkedin: '#',
      twitter: '#',
      github: '#',
    },
    {
      name: 'Priya Sharma',
      role: 'CTO',
      image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400&h=400&fit=crop&crop=face',
      bio: 'Tech enthusiast specializing in AI & Cloud solutions',
      linkedin: '#',
      twitter: '#',
      github: '#',
    },
    {
      name: 'Arun Patel',
      role: 'Lead Developer',
      image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&h=400&fit=crop&crop=face',
      bio: 'Full-stack developer with expertise in React & Node.js',
      linkedin: '#',
      twitter: '#',
      github: '#',
    },
    {
      name: 'Sneha Reddy',
      role: 'UI/UX Designer',
      image: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=400&h=400&fit=crop&crop=face',
      bio: 'Creative designer passionate about user experience',
      linkedin: '#',
      twitter: '#',
      github: '#',
    },
    {
      name: 'Vikram Singh',
      role: 'DevOps Engineer',
      image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=400&fit=crop&crop=face',
      bio: 'Cloud infrastructure expert with AWS certifications',
      linkedin: '#',
      twitter: '#',
      github: '#',
    },
    {
      name: 'Kavya Nair',
      role: 'Project Manager',
      image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400&h=400&fit=crop&crop=face',
      bio: 'Agile certified PM ensuring timely project delivery',
      linkedin: '#',
      twitter: '#',
      github: '#',
    },
  ];

  return (
    <section id="team" className="py-32 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-24">
          <div className="inline-block bg-white px-6 py-3 rounded-full shadow-sm mb-6">
            <span className="text-green-600 font-semibold">Our Team</span>
          </div>
          <h2 className="text-4xl md:text-6xl font-black text-gray-900 mb-6">
            Meet Our <span className="text-gradient">Experts</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            A talented team of professionals dedicated to delivering exceptional results for our clients.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {teamMembers.map((member, index) => (
            <div 
              key={index}
              className="team-card bg-white rounded-3xl overflow-hidden shadow-lg reveal-element"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="relative overflow-hidden">
                <img 
                  src={member.image} 
                  alt={member.name} 
                  className="team-image w-full h-72 object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent"></div>
                <div className="team-social absolute bottom-4 left-0 right-0 flex justify-center gap-3">
                  <a 
                    href={member.linkedin} 
                    className="w-10 h-10 bg-white rounded-full flex items-center justify-center text-gray-700 hover:bg-green-500 hover:text-white transition-all"
                  >
                    <i className="fab fa-linkedin-in"></i>
                  </a>
                  <a 
                    href={member.twitter} 
                    className="w-10 h-10 bg-white rounded-full flex items-center justify-center text-gray-700 hover:bg-blue-500 hover:text-white transition-all"
                  >
                    <i className="fab fa-twitter"></i>
                  </a>
                  <a 
                    href={member.github} 
                    className="w-10 h-10 bg-white rounded-full flex items-center justify-center text-gray-700 hover:bg-gray-900 hover:text-white transition-all"
                  >
                    <i className="fab fa-github"></i>
                  </a>
                </div>
              </div>
              <div className="p-6 text-center">
                <h3 className="text-xl font-bold text-gray-900 mb-1">{member.name}</h3>
                <p className="text-green-600 font-semibold mb-3">{member.role}</p>
                <p className="text-gray-600 text-sm">{member.bio}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-16">
          <Link 
            to="/contact"
            className="inline-flex items-center gap-2 magnetic-btn bg-green-500 text-white px-8 py-4 rounded-full font-semibold hover:bg-green-600 transition-all shadow-lg hover:shadow-green-500/30"
          >
            Join Our Team
            <i className="fas fa-arrow-right"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}

export default Team;